import { Resources } from 'constants/resources';

import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';

export const getEntitiesList = async (): Promise<AxiosResponse<Record<string, string>>> => {
  return axios
    .get('user_action/entities')
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const getJsonSchema = async (id: string): Promise<any> => {
  return axios
    .get(`${Resources.UserActions}/${id}/json`)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
